import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import SelfPlanner from "./component/SelfPlanner/Singn/SelfPlanner";
import SelfChecking from "./component/selfchecking/index/SelfChecking";
import Registration from "./component/selfchecking/RegisterNow/Registration";
import VenuePayment from "./component/SelfPlanner/VenuePayment/VenuePayment";
import Dashboard from "./component/Dashboard/Dashboard";
import Congratulations from "./component/selfchecking/Congratulations/Congratulations";
import AfterPaymentScreen from "./component/AfterPaymentScreen";
import ConfirmBooking from "./component/ConfirmBooking";
import EventListing from "./component/EventListing/Eventlisting";
import ReadMore from "./component/Enquiry/ReadMore/Readmore";

import SelfClassroom from "./component/ClassroomComponent/SelfClassroom";
import Classroomregistration from "./component/ClassroomComponent/Classroomregistration";
import Classroomvenupayment from "./component/ClassroomComponent/classroomPayment/Classroomvenupayment";
import Readmoreclassroom from "./component/ClassroomComponent/Readmoreclassroom/Readmoreclassroom";
import ClassRoomNewRegistration from "./component/ClassroomComponent/classRoomNewRegister";

import Mailtocoordinator from "./component/Mailtocoordinator";
import QrCodeScanner from "./component/QrCodeScanner";
import SelfCheckingByQr from "./component/SelfCheckingByQr";

import commonLib from "./control/commonLib";
import { isNotValidNullUndefinedfile } from "./control/Constant";

export const UserContext = React.createContext({
  subtenantLogo: "",
  setSubtenantLogo: () => {},
  loader: false,
  setLoader: () => {},
});

function App() {
  const [subtenantLogo, setSubtenantLogo] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const seminarObj = commonLib.getObjFromStorage("seminarObj");

    if (isNotValidNullUndefinedfile(seminarObj)) {
      setSubtenantLogo(
        seminarObj.logoUrl || seminarObj.subtenantLogoUrl || ""
      );
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        subtenantLogo,
        setSubtenantLogo,
        loader,
        setLoader,
      }}
    >
      <div className="overlay position-relative">
        {loader && (
          <div className="d-flex align-items-center justify-content-center position-absolute overLayLoader">
            <div
              className="spinner-border"
              role="status"
              aria-hidden="true"
            />
          </div>
        )}

        <BrowserRouter>
          <Routes>
            <Route path="/Register" element={<Registration />} />

            <Route
              path="/Congratulations"
              element={<Congratulations />}
            />

            <Route path="/SelfChecking" element={<SelfChecking />} />

            <Route path="/UserBooking" element={<VenuePayment />} />

            <Route
              path="/selectBooking"
              element={<AfterPaymentScreen />}
            />

            <Route path="/SelfPlanner" element={<SelfPlanner />} />

            <Route
              path="/ConfirmBooking"
              element={<ConfirmBooking />}
            />

            <Route
              path="/EventListing/:subtenantKey"
              element={<EventListing />}
            />

            <Route path="/" element={<EventListing />} />

            <Route
              path="/EventListing/:subtenantKey/:seminarid"
              element={<ReadMore />}
            />

            <Route
              path="/Readmore/:subtenantKey/:seminarid"
              element={<ReadMore />}
            />

            <Route
              path="/AfterPaymentScreen"
              element={<AfterPaymentScreen />}
            />

            <Route path="/Account" element={<Dashboard />} />

            <Route
              path="/Classroomreg"
              element={<Classroomregistration />}
            />

            <Route
              path="/classroomvanupayment"
              element={<Classroomvenupayment />}
            />

            <Route
              path="/readmoreprofessclassroom"
              element={<Readmoreclassroom />}
            />

            <Route
              path="/selfClassroom"
              element={<SelfClassroom />}
            />

            <Route
              path="/newClassroomRegistration"
              element={<ClassRoomNewRegistration />}
            />

            <Route
              path="/Mailtocoordinator"
              element={<Mailtocoordinator />}
            />

            <Route
              path="/qrcodescanner"
              element={<QrCodeScanner />}
            />

            <Route
              path="/SelfcheckbyQr"
              element={<SelfCheckingByQr />}
            />
          </Routes>
        </BrowserRouter>
      </div>
    </UserContext.Provider>
  );
}

export default App;